import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalViewNews from "./ModalViewNews";

const useModalViewNews = ( onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, news_id: null})  ;

    const onClickActivate = ( news_id ) =>
    {
        setDialog ({ openState: true, news_id: news_id});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, news_id: null, key: null});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, news_id: null});

        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalViewNews news_id={dialog.news_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} />
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalViewNews ;
